import type { FC } from 'react';
import React from 'react';

import { Slider } from '../Slider/Slider';
import styles from './VolumeSlider.module.scss';

type VolumeSliderProps = {
  volume: number;
  onVolumeChange: (volume: number) => void;
};

export const VolumeSlider: FC<VolumeSliderProps> = ({
  volume,
  onVolumeChange,
}) => {
  return (
    <Slider
      className={styles.volumeSlider}
      orientation="vertical"
      value={volume}
      min={0}
      max={1}
      ariaLabel="Volume"
      ariaValueMin={0}
      ariaValueMax={100}
      ariaValueNow={Math.round(volume * 100)}
      tabIndex={-1}
      onChange={onVolumeChange}
      onClick={onVolumeChange}
    />
  );
};
